import { render, staticRenderFns } from "./WithdrawalModalText.vue?vue&type=template&id=4614b7af&scoped=true&"
import script from "./WithdrawalModalText.vue?vue&type=script&lang=js&"
export * from "./WithdrawalModalText.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalModalText.vue?vue&type=style&index=0&id=4614b7af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4614b7af",
  null
  
)

export default component.exports